import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

export interface NavigationPage {
  label: string;
  value: string;
  route: string;
}

export interface NavigationResult {
  pages: NavigationPage[];
  currentPage: string;
}

const NAVIGATION_PAGES = [
  { value: 'policy', route: '/policy', translationKey: 'policyList' },
  { value: 'billing', route: '/billing', translationKey: 'billingList' },
  {
    value: 'renewal-prioritizer',
    route: '/renewal-prioritizer',
    translationKey: 'renewalPrioritizer',
  },
] as const;

export const usePagesNavigation = (): NavigationResult => {
  const { t } = useTranslation();
  const location = useLocation();

  const pages: NavigationPage[] = NAVIGATION_PAGES.map((page) => ({
    value: page.value,
    route: page.route,
    label: t(page.translationKey),
  }));

  const currentPage =
    NAVIGATION_PAGES.find((page) => location.pathname.startsWith(page.route))
      ?.value ?? NAVIGATION_PAGES[0]?.value;

  return {
    pages,
    currentPage,
  };
};
